import { parseColor } from '@ark-ui/react'
import { theme } from '@qr-front/ui'
import { cn, isColorWhite } from '@qr-front/ui/utils'
import { CSSProperties } from 'react'

import { getContrastingNeutralColor } from '@/utils'

export const useColoredButton = (color: string) => {
	const contrastingColor = getContrastingNeutralColor(color)

	if (isColorWhite(parseColor)(color)) {
		return {
			coloredButtonCls: cn('hover:bg-transparent'),
			coloredButtonStyle: {
				'--tw-ring-color': theme.colors.black,
				color: theme.colors.black,
			} as CSSProperties,
		}
	}

	return {
		coloredButtonCls: cn('ring-transparent'),
		coloredButtonStyle: {
			backgroundColor: color,
			color: contrastingColor,
		} as CSSProperties,
	}
}
